export default __webpack_public_path__ + "maps-examples-custom-style-960-63142207c6f65cf3b042e07a39c43bff.webp";